export const zh = {
  nav: {
    home: '首页',
    mining: '挖矿',
    fuel: '燃料池',
    team: '舰队',
    assets: '资产',
  },
  common: {
    connectWallet: '连接钱包',
    disconnect: '断开连接',
    loading: '加载中...',
    confirm: '确认',
    cancel: '取消',
    success: '成功',
    error: '错误',
  },
  wallet: {
    title: '连接钱包',
    detected: '已检测到',
    notInstalled: '未安装',
    install: '安装',
    connecting: '连接中...',
    terms: '连接钱包即表示您同意我们的服务条款',
    connectFailed: '连接钱包失败，请重试',
    pleaseInstall: '请先安装',
  },
  home: {
    title: '星际探索协议',
    subtitle: '创新的去中心化挖矿协议，融合双时段挖矿、燃料池退税、舰队协作和资产管理',
    subtitleHighlight: '构建下一代DeFi生态系统',
    connectStart: '连接钱包开始',
    viewMining: '查看挖矿',
    basedOnBSC: '基于BSC主网',
    keyMetrics: '平台关键指标',
    keyMetricsDesc: '实时数据展示，透明可信',
    activeUsers: '活跃用户',
    totalVolume: '总交易量',
    tvl: '锁仓价值',
    coreFeatures: '核心功能模块',
    coreFeaturesDesc: '四大核心系统，构建完整DeFi生态',
    systemOverview: '系统概览',
    systemOverviewDesc: '智能合约地址与网络信息',
    contractAddress: '合约地址',
    networkName: '网络名称',
    chainId: '链ID',
    investmentHighlights: '投资亮点',
    investmentHighlightsDesc: '为什么选择星际探索协议',
    secure: '安全',
    secureTitle: '智能合约审计',
    secureDesc: '完全开源的智能合约代码，透明可信的链上执行，多重安全保障机制',
    profit: '收益',
    profitTitle: '多重收益来源',
    profitDesc: '挖矿奖励、推荐分成、燃料退税、抽奖奖励，多元化收益体系',
    innovation: '创新',
    innovationTitle: '创新经济模型',
    innovationDesc: '双时段挖矿机制、舰队协作系统、周榜排名竞争，独特的经济设计',
  },
  features: {
    mining: {
      title: '双时段挖矿',
      desc: '严格的12小时制时间窗口控制，智能合约时间校验，防止脚本刷取，确保公平参与',
      timeWindow: '时间窗口',
      smartVerify: '智能校验',
    },
    fuel: {
      title: '燃料池退税',
      desc: 'Gas自动退税机制，每日权重抽奖系统，USDT奖励累计，降低交易成本',
      autoRefund: '自动退税',
      dailyReward: '抽奖奖励',
    },
    team: {
      title: '舰队协作',
      desc: '团队创建与绑定，推荐链条层级关系，周榜排名竞争，团队贡献度累计',
      weeklyRank: '排名竞争',
      teamWork: '协作共赢',
    },
    assets: {
      title: '资产管理',
      desc: 'USDT奖励累计，30USDT提现门槛，完全透明的链上管理，安全高效的资产控制',
      withdrawLimit: '提现门槛',
      onChain: '链上管理',
    },
  },
  mining: {
    title: '双时段挖矿',
    subtitle: '严格的12小时制交互逻辑，智能合约时间校验，防止脚本刷取，确保公平参与',
    miningSystem: '挖矿系统',
    totalMining: '总挖矿次数',
    successRate: '挖矿成功率',
    miningCycle: '挖矿周期',
    availability: '系统可用性',
    fixed: '固定',
    online: '上线',
    coreFeatures: '核心特性',
    coreFeaturesDesc: '专业的挖矿机制设计',
    timeWindow: '12小时时间窗口',
    timeWindowDesc: '严格的12小时制时间控制机制，确保挖矿活动的有序进行',
    smartContract: '智能合约时间校验',
    smartContractDesc: '链上时间验证，防止时间操纵和脚本刷取',
    antiCheat: '防刷机制',
    antiCheatDesc: '多重安全验证，确保只有真实用户可以参与挖矿',
    earlyReward: '早期用户奖励',
    earlyRewardDesc: '早期参与者获得额外的挖矿奖励加成',
    dashboard: '挖矿操作面板',
    dashboardDesc: '实时挖矿状态与操作',
    sequence: '星际挖矿序列',
    sequenceDesc: '严格的双时段挖矿系统',
    firstSequence: '第一序列',
    secondSequence: '第二序列',
    inProgress: '进行中',
    waitingForSlot: '等待时段开始',
    nextSlot: '距离下一时段',
    miningInteraction: '挖矿交互',
    startMining: '开始探索挖矿',
    pleaseConnect: '请先连接钱包',
    recharging: '探索能量补充中',
    walletStatus: '钱包状态',
    connected: '已连接',
    currentSlot: '当前时段',
    todayInteraction: '今日交互',
    completed: '已完成',
    waitingNextSlot: '等待下一时段',
    todayRecords: '今日交互记录',
    noRecords: '今日暂无交互记录',
    serverTime: '服务器时间',
    serverStatus: '服务器状态',
    normal: '正常',
    connectingServer: '连接挖矿服务器中...',
    retryConnect: '重试连接',
  },
  fuel: {
    title: '星际燃料池',
    subtitle: 'Gas退税与每日抽奖系统，让您的每一笔交易都有回报，降低参与成本',
    fuelSystem: '燃料池系统',
    totalRefund: '累计退税金额',
    thisMonth: '本月',
    thisWeek: '本周',
    yesterday: '昨日',
    realtime: '实时',
    refundUsers: '退税用户数',
    todayLottery: '今日抽奖次数',
    todayWin: '今日中奖金额',
    coreAdvantages: '核心优势',
    coreAdvantagesDesc: '创新的燃料池机制设计',
    gasAutoRefund: 'Gas自动退税',
    gasAutoRefundDesc: '智能合约自动计算Gas消耗，按比例返还至燃料池，降低用户交易成本',
    dailyLottery: '每日权重抽奖',
    dailyLotteryDesc: '基于贡献度的权重随机抽奖系统，贡献越多中奖概率越高',
    usdtReward: 'USDT奖励累计',
    usdtRewardDesc: '中奖获得USDT奖励，自动累计到用户账户，达到门槛即可提现',
    transparentAllocation: '透明分配机制',
    transparentAllocationDesc: '完全透明的链上分配，所有记录可查，公平公正公开',
    dashboard: '燃料池操作面板',
    dashboardDesc: '实时退税状态与抽奖信息',
  },
  team: {
    title: '星际舰队系统',
    subtitle: '团队创建与绑定，推荐链条层级关系，周榜排名竞争，与朋友一起探索星际宇宙',
    teamSystem: '舰队系统',
    activeFleets: '活跃舰队数',
    totalMembers: '团队成员总数',
    totalContribution: '团队总贡献',
    lastWeek: '上周',
    ongoing: '进行中',
    rankingCompetition: '排名竞争',
    systemFeatures: '系统特性',
    systemFeaturesDesc: '强大的团队协作机制',
    referralBinding: '推荐链条绑定',
    referralBindingDesc: '智能合约自动管理推荐关系，多层级团队结构，确保推荐关系清晰可追溯',
    weeklyRanking: '周榜排名竞争',
    weeklyRankingDesc: '每周重置的贡献度排行榜，激励团队竞争，排名靠前获得额外奖励',
    teamContribution: '团队贡献度累计',
    teamContributionDesc: '所有团队成员的贡献自动累计，团队总贡献决定排名位置',
    honorDisplay: '荣誉展示系统',
    honorDisplayDesc: '优秀团队和个人的荣誉展示，增强社区荣誉感和归属感',
    dashboard: '舰队操作面板',
    dashboardDesc: '团队管理与排名查看',
  },
  assets: {
    title: '资产管理',
    subtitle: 'USDT奖励累计与30U提现门槛，安全透明的链上资产管理系统，高效可控',
    assetManagement: '资产管理',
    totalAssets: '平台总资管',
    totalTransactions: '总交易笔数',
    last7Days: '7日',
    userProfit: '用户收益率',
    monthOverMonth: '环比',
    fundSecurity: '资金安全',
    guarantee: '保障',
    securityFeatures: '安全特性',
    securityFeaturesDesc: '专业的资产管理设计',
    realtimeBalance: '实时余额管理',
    realtimeBalanceDesc: '实时查看STORM和USDT余额，所有资产状态一目了然，透明可信',
    usdtRewardAccumulation: 'USDT奖励累计',
    usdtRewardAccumulationDesc: '燃料池抽奖奖励自动累计，清晰的收益记录，每一笔都可追溯',
    secureWithdrawal: '安全提现机制',
    secureWithdrawalDesc: '30USDT门槛提现，智能合约自动执行，安全可靠的资金转出',
    fullyOnChain: '完全链上管理',
    fullyOnChainDesc: '所有资产管理都在链上执行，完全透明，任何人都可验证',
    dashboard: '资产操作面板',
    dashboardDesc: '余额查询与提现管理',
  },
  footer: {
    copyright: '© 2024 星际探索协议. 基于BSC网络构建',
    tagline: '安全 · 透明 · 高效',
  },
  miningDashboard: {
    loadingTimeSlots: '加载时段信息...',
    miningSequence: '星际挖矿序列',
    dualTimeSystem: '严格的双时段挖矿系统',
    firstSequence: '第一序列',
    secondSequence: '第二序列',
    inProgress: '进行中',
    nextSlotIn: '距离下一时段',
    miningInteraction: '挖矿交互',
    pleaseConnectWallet: '请先连接钱包',
    waitingForSlot: '等待时段开始',
    recharging: '探索能量补充中',
    interacting: '交互中...',
    startMining: '开始探索挖矿',
    walletStatus: '钱包状态',
    connected: '已连接',
    currentSlot: '当前时段',
    todayInteraction: '今日交互',
    completed: '已完成',
    waitingNextSlot: '等待下一时段',
    todayRecords: '今日交互记录',
    noRecords: '今日暂无交互记录',
    serverTime: '服务器时间',
    serverStatus: '服务器状态',
    normal: '正常',
    connectingServer: '连接挖矿服务器中...',
    retryConnect: '重试连接',
    loading: '加载中...',
    serverConnectionFailed: '服务器连接失败',
    dataLoadFailed: '数据加载失败',
    interactionFailed: '交互失败',
  },
  fuelDashboard: {
    loadingFuelData: '加载燃料池数据...',
    fuelPoolStats: '星际燃料池统计',
    participants: '参与用户',
    totalInteractions: '总交互次数',
    totalGas: '总Gas消耗',
    topPoints: '最高积分',
    myFuelData: '我的燃料池数据',
    noFuelData: '今日暂无燃料池数据',
    interactionCount: '交互次数',
    gasConsumed: 'Gas消耗',
    dailyPoints: '每日积分',
    currentRank: '当前排名',
    notOnList: '未上榜',
    top100Message: '🎉 恭喜！您已进入前100名，有机会参与每日抽奖！',
    referralBonusActive: '⭐ 推荐加成已激活',
    luckyExplorers: '幸运探索者公告栏',
    noWinners: '暂无中奖记录',
    winners: '名中奖者',
    points: '积分',
    lotteryInfo: '每日从业绩榜前100名中随机抽取5名幸运探索者',
    todayLeaderboard: '今日业绩榜',
    todayLeaderboardTop20: '今日业绩榜 TOP 20',
    noRankingData: '暂无排名数据',
    interactions: '次交互',
    fuelPoolRules: '燃料池规则说明',
    rule1: '每次有效交互记录 0.5-0.6 虚拟Gas消耗',
    rule2: '每日积分 = 交互次数 + 推荐加成 (20%)',
    rule3: '每日UTC 0点从业绩榜前100名中随机抽取5名幸运探索者',
    rule4: '中奖者获得 100 USDT 奖励',
    rule5: '积分越高，中奖概率越大',
  },
  teamDashboard: {
    loadingTeamData: '加载团队信息...',
    myFleet: '我的星际舰队',
    fleetMembers: '舰队成员',
    fleetName: '舰队名称',
    inviteCode: '邀请码',
    inviteFriends: '邀请好友加入舰队',
    copy: '复制',
    shareInviteCode: '分享此邀请码给好友，让他们加入您的星际舰队！',
    joinFleet: '加入星际舰队',
    enterInviteCode: '请输入邀请码',
    inviteCodePlaceholder: '输入舰队邀请码 (如: STORM1234)',
    joining: '加入中...',
    joinFleetBtn: '加入舰队',
    joinFleetDesc: '通过邀请码加入朋友的星际舰队，共同提升贡献度！',
    thisWeekRankings: '本周贡献榜',
    thisWeekRankingsTop20: '本周贡献榜 TOP 20',
    noRankingData: '暂无排名数据',
    members: '名成员',
    contributionRule1: '贡献度 = 团长个人交互 + 队员总交互 × 10%',
    contributionRule2: '每周一更新排名，前20名舰队上榜',
    contributionExplanation: '贡献度计算规则',
    captainContribution: '👑 团长贡献度',
    captainContributionFormula: '= 个人交互次数 + (所有队员交互次数 × 10%)',
    memberContribution: '👥 队员贡献度',
    memberContributionFormula: '= 个人交互次数（直接计入团队总贡献）',
    teamTotalContribution: '📊 团队总贡献',
    teamTotalContributionFormula: '= 所有成员贡献度之和（用于周榜排名）',
    tip: '💡 提示：邀请更多好友加入舰队，可以显著提升团队贡献度！',
    createFleet: '创建星际舰队',
    noFleetYet: '还没有舰队？创建自己的星际舰队！',
    createMyFleet: '创建我的舰队',
    pleaseConnectWallet: '请先连接钱包',
    joinSuccess: '成功加入舰队！',
    joinFailed: '加入舰队失败',
    createSuccess: '舰队创建成功！',
    createFailed: '创建舰队失败',
    pleaseRetry: '请重试',
  },
  assetDashboard: {
    loadingAssetData: '加载资产数据...',
    myAssets: '我的资产',
    usdtBalance: 'USDT 余额',
    canWithdraw: '✓ 可提现',
    charging: '⏳ 蓄能中',
    thresholdReached: '已达到提现门槛',
    stillNeed: '还需 {amount} USDT',
    withdrawalThreshold: '提现门槛: {amount} USDT',
    usdtWithdrawal: 'USDT 提现',
    withdrawalAddress: '提现地址',
    withdrawalAddressPlaceholder: '输入接收USDT的钱包地址 (0x...)',
    withdrawalAmount: '提现金额 (USDT)',
    withdrawalAmountPlaceholder: '{min} - {max}',
    all: '全部',
    needThreshold: '需达到 {amount} USDT 能量方可传送',
    invalidAddress: '请输入有效的提现地址',
    invalidAmount: '请输入有效的提现金额',
    amountExceeds: '提现金额超过可用余额',
    minWithdrawal: '最低提现金额为 {amount} USDT',
    submitting: '提交中...',
    submitWithdrawal: '提交提现申请',
    withdrawalTip1: '💡 提现申请提交后需要管理员审核',
    withdrawalTip2: '⏰ 审核通过后将在1-3个工作日内处理',
    transactionHistory: '交易历史',
    noTransactions: '暂无交易记录',
    rewardIncome: '奖励收入',
    withdrawalRequest: '提现申请',
    completed: '已完成',
    pending: '处理中',
    rejected: '已拒绝',
    showRecent: '显示最近 {count} 笔交易记录',
    rewardSources: '奖励来源',
    dailyLottery: '每日抽奖',
    dailyLotteryDesc: '每日从业绩榜前100名中随机抽取5名幸运儿，奖励100 USDT',
    weeklyAirdrop: '周榜空投',
    weeklyAirdropDesc: '每周贡献榜前20名舰队成员可获得USDT空投奖励',
    interstellarExploration: '星际探索',
    interstellarExplorationDesc: '参与双时段挖矿交互，积累探索能量和潜在奖励',
    teamBonus: '团队加成',
    teamBonusDesc: '舰队团长可获得团队成员交互次数的10%加成',
    connectWalletToView: '连接钱包查看资产',
    connectWalletDesc: '请先连接您的钱包以查看USDT余额和交易历史',
    pleaseConnectWallet: '请先连接钱包',
    withdrawalSuccess: '提现申请提交成功！请等待管理员审核。',
    withdrawalFailed: '提现申请失败',
  },
}

export const en = {
  nav: {
    home: 'Home',
    mining: 'Mining',
    fuel: 'Fuel Pool',
    team: 'Team',
    assets: 'Assets',
  },
  common: {
    connectWallet: 'Connect Wallet',
    disconnect: 'Disconnect',
    loading: 'Loading...',
    confirm: 'Confirm',
    cancel: 'Cancel',
    success: 'Success',
    error: 'Error',
  },
  wallet: {
    title: 'Connect Wallet',
    detected: 'Detected',
    notInstalled: 'Not Installed',
    install: 'Install',
    connecting: 'Connecting...',
    terms: 'By connecting your wallet, you agree to our Terms of Service',
    connectFailed: 'Failed to connect wallet, please try again',
    pleaseInstall: 'Please install',
  },
  home: {
    title: 'Interstellar Exploration Protocol',
    subtitle: 'Innovative decentralized mining protocol, integrating dual-time mining, fuel pool tax refund, fleet collaboration and asset management',
    subtitleHighlight: 'Building the next generation DeFi ecosystem',
    connectStart: 'Connect Wallet to Start',
    viewMining: 'View Mining',
    basedOnBSC: 'Based on BSC Mainnet',
    keyMetrics: 'Platform Key Metrics',
    keyMetricsDesc: 'Real-time data display, transparent and trustworthy',
    activeUsers: 'Active Users',
    totalVolume: 'Total Volume',
    tvl: 'Total Value Locked',
    coreFeatures: 'Core Features',
    coreFeaturesDesc: 'Four core systems, building a complete DeFi ecosystem',
    systemOverview: 'System Overview',
    systemOverviewDesc: 'Smart contract address and network information',
    contractAddress: 'Contract Address',
    networkName: 'Network Name',
    chainId: 'Chain ID',
    investmentHighlights: 'Investment Highlights',
    investmentHighlightsDesc: 'Why choose Interstellar Exploration Protocol',
    secure: 'Secure',
    secureTitle: 'Smart Contract Audit',
    secureDesc: 'Fully open-source smart contract code, transparent and trustworthy on-chain execution, multiple security guarantee mechanisms',
    profit: 'Profit',
    profitTitle: 'Multiple Revenue Sources',
    profitDesc: 'Mining rewards, referral commissions, fuel tax refunds, lottery rewards, diversified revenue system',
    innovation: 'Innovation',
    innovationTitle: 'Innovative Economic Model',
    innovationDesc: 'Dual-time mining mechanism, fleet collaboration system, weekly ranking competition, unique economic design',
  },
  features: {
    mining: {
      title: 'Dual-Time Mining',
      desc: 'Strict 12-hour time window control, smart contract time verification, prevent script cheating, ensure fair participation',
      timeWindow: 'Time Window',
      smartVerify: 'Smart Verify',
    },
    fuel: {
      title: 'Fuel Pool Tax Refund',
      desc: 'Gas automatic refund mechanism, daily weight lottery system, USDT reward accumulation, reduce transaction costs',
      autoRefund: 'Auto Refund',
      dailyReward: 'Daily Reward',
    },
    team: {
      title: 'Fleet Collaboration',
      desc: 'Team creation and binding, referral chain hierarchy, weekly ranking competition, team contribution accumulation',
      weeklyRank: 'Weekly Rank',
      teamWork: 'Team Work',
    },
    assets: {
      title: 'Asset Management',
      desc: 'USDT reward accumulation, 30 USDT withdrawal threshold, fully transparent on-chain management, safe and efficient asset control',
      withdrawLimit: 'Withdraw Limit',
      onChain: 'On-Chain',
    },
  },
  mining: {
    title: 'Dual-Time Mining',
    subtitle: 'Strict 12-hour interaction logic, smart contract time verification, prevent script cheating, ensure fair participation',
    miningSystem: 'Mining System',
    totalMining: 'Total Mining',
    successRate: 'Success Rate',
    miningCycle: 'Mining Cycle',
    availability: 'System Availability',
    fixed: 'Fixed',
    online: 'Online',
    coreFeatures: 'Core Features',
    coreFeaturesDesc: 'Professional mining mechanism design',
    timeWindow: '12-Hour Time Window',
    timeWindowDesc: 'Strict 12-hour time control mechanism to ensure orderly mining activities',
    smartContract: 'Smart Contract Verification',
    smartContractDesc: 'On-chain time verification, prevent time manipulation and script cheating',
    antiCheat: 'Anti-Cheat Mechanism',
    antiCheatDesc: 'Multiple security verification to ensure only real users can participate in mining',
    earlyReward: 'Early User Rewards',
    earlyRewardDesc: 'Early participants receive additional mining reward bonuses',
    dashboard: 'Mining Dashboard',
    dashboardDesc: 'Real-time mining status and operations',
    sequence: 'Mining Sequence',
    sequenceDesc: 'Strict dual-time mining system',
    firstSequence: 'First Sequence',
    secondSequence: 'Second Sequence',
    inProgress: 'In Progress',
    waitingForSlot: 'Waiting for Slot',
    nextSlot: 'Next Slot In',
    miningInteraction: 'Mining Interaction',
    startMining: 'Start Mining',
    pleaseConnect: 'Please Connect Wallet',
    recharging: 'Recharging Energy',
    walletStatus: 'Wallet Status',
    connected: 'Connected',
    currentSlot: 'Current Slot',
    todayInteraction: 'Today\'s Interaction',
    completed: 'Completed',
    waitingNextSlot: 'Waiting Next Slot',
    todayRecords: 'Today\'s Records',
    noRecords: 'No records today',
    serverTime: 'Server Time',
    serverStatus: 'Server Status',
    normal: 'Normal',
    connectingServer: 'Connecting to mining server...',
    retryConnect: 'Retry Connection',
  },
  fuel: {
    title: 'Interstellar Fuel Pool',
    subtitle: 'Gas refund and daily lottery system, making every transaction rewarding, reducing participation costs',
    fuelSystem: 'Fuel Pool System',
    totalRefund: 'Total Refund',
    thisMonth: 'This Month',
    thisWeek: 'This Week',
    yesterday: 'Yesterday',
    realtime: 'Realtime',
    refundUsers: 'Refund Users',
    todayLottery: 'Today\'s Lottery',
    todayWin: 'Today\'s Win',
    coreAdvantages: 'Core Advantages',
    coreAdvantagesDesc: 'Innovative fuel pool mechanism design',
    gasAutoRefund: 'Gas Auto Refund',
    gasAutoRefundDesc: 'Smart contract automatically calculates Gas consumption, proportional refund to fuel pool, reducing user transaction costs',
    dailyLottery: 'Daily Weight Lottery',
    dailyLotteryDesc: 'Weighted random lottery system based on contribution, the more you contribute, the higher the winning probability',
    usdtReward: 'USDT Reward Accumulation',
    usdtRewardDesc: 'Winning USDT rewards automatically accumulate to user account, withdrawal available when threshold is reached',
    transparentAllocation: 'Transparent Allocation',
    transparentAllocationDesc: 'Fully transparent on-chain allocation, all records verifiable, fair and open',
    dashboard: 'Fuel Pool Dashboard',
    dashboardDesc: 'Real-time refund status and lottery information',
  },
  team: {
    title: 'Interstellar Fleet System',
    subtitle: 'Team creation and binding, referral chain hierarchy, weekly ranking competition, explore the interstellar universe with friends',
    teamSystem: 'Fleet System',
    activeFleets: 'Active Fleets',
    totalMembers: 'Total Members',
    totalContribution: 'Total Contribution',
    lastWeek: 'Last Week',
    ongoing: 'Ongoing',
    rankingCompetition: 'Ranking Competition',
    systemFeatures: 'System Features',
    systemFeaturesDesc: 'Powerful team collaboration mechanism',
    referralBinding: 'Referral Chain Binding',
    referralBindingDesc: 'Smart contract automatically manages referral relationships, multi-level team structure, ensuring clear and traceable referral relationships',
    weeklyRanking: 'Weekly Ranking Competition',
    weeklyRankingDesc: 'Weekly reset contribution leaderboard, motivating team competition, top ranked teams receive extra rewards',
    teamContribution: 'Team Contribution Accumulation',
    teamContributionDesc: 'Contributions from all team members are automatically accumulated, total team contribution determines ranking position',
    honorDisplay: 'Honor Display System',
    honorDisplayDesc: 'Honor display for excellent teams and individuals, enhancing community sense of honor and belonging',
    dashboard: 'Fleet Dashboard',
    dashboardDesc: 'Team management and ranking view',
  },
  assets: {
    title: 'Asset Management',
    subtitle: 'USDT reward accumulation and 30U withdrawal threshold, safe and transparent on-chain asset management system, efficient and controllable',
    assetManagement: 'Asset Management',
    totalAssets: 'Total Assets',
    totalTransactions: 'Total Transactions',
    last7Days: 'Last 7 Days',
    userProfit: 'User Profit Rate',
    monthOverMonth: 'MoM',
    fundSecurity: 'Fund Security',
    guarantee: 'Guaranteed',
    securityFeatures: 'Security Features',
    securityFeaturesDesc: 'Professional asset management design',
    realtimeBalance: 'Real-time Balance',
    realtimeBalanceDesc: 'Real-time view of STORM and USDT balances, all asset status at a glance, transparent and trustworthy',
    usdtRewardAccumulation: 'USDT Reward Accumulation',
    usdtRewardAccumulationDesc: 'Fuel pool lottery rewards automatically accumulate, clear income records, every transaction traceable',
    secureWithdrawal: 'Secure Withdrawal',
    secureWithdrawalDesc: '30USDT withdrawal threshold, smart contract automatic execution, safe and reliable fund transfer',
    fullyOnChain: 'Fully On-Chain',
    fullyOnChainDesc: 'All asset management executed on-chain, fully transparent, verifiable by anyone',
    dashboard: 'Asset Dashboard',
    dashboardDesc: 'Balance query and withdrawal management',
  },
  footer: {
    copyright: '© 2024 Interstellar Exploration Protocol. Built on BSC Network',
    tagline: 'Secure · Transparent · Efficient',
  },
  miningDashboard: {
    loadingTimeSlots: 'Loading time slot info...',
    miningSequence: 'Mining Sequence',
    dualTimeSystem: 'Strict dual-time mining system',
    firstSequence: 'First Sequence',
    secondSequence: 'Second Sequence',
    inProgress: 'In Progress',
    nextSlotIn: 'Next Slot In',
    miningInteraction: 'Mining Interaction',
    pleaseConnectWallet: 'Please Connect Wallet',
    waitingForSlot: 'Waiting for Slot',
    recharging: 'Recharging Energy',
    interacting: 'Interacting...',
    startMining: 'Start Mining',
    walletStatus: 'Wallet Status',
    connected: 'Connected',
    currentSlot: 'Current Slot',
    todayInteraction: 'Today\'s Interaction',
    completed: 'Completed',
    waitingNextSlot: 'Waiting Next Slot',
    todayRecords: 'Today\'s Records',
    noRecords: 'No records today',
    serverTime: 'Server Time',
    serverStatus: 'Server Status',
    normal: 'Normal',
    connectingServer: 'Connecting to mining server...',
    retryConnect: 'Retry Connection',
    loading: 'Loading...',
    serverConnectionFailed: 'Server connection failed',
    dataLoadFailed: 'Data loading failed',
    interactionFailed: 'Interaction failed',
  },
  fuelDashboard: {
    loadingFuelData: 'Loading fuel pool data...',
    fuelPoolStats: 'Fuel Pool Stats',
    participants: 'Participants',
    totalInteractions: 'Total Interactions',
    totalGas: 'Total Gas',
    topPoints: 'Top Points',
    myFuelData: 'My Fuel Data',
    noFuelData: 'No fuel data today',
    interactionCount: 'Interactions',
    gasConsumed: 'Gas Consumed',
    dailyPoints: 'Daily Points',
    currentRank: 'Current Rank',
    notOnList: 'Not On List',
    top100Message: '🎉 Congratulations! You are in Top 100, eligible for daily lottery!',
    referralBonusActive: '⭐ Referral Bonus Active',
    luckyExplorers: 'Lucky Explorers Board',
    noWinners: 'No winners yet',
    winners: 'Winners',
    points: 'Points',
    lotteryInfo: '5 lucky explorers randomly selected daily from Top 100',
    todayLeaderboard: 'Today\'s Leaderboard',
    todayLeaderboardTop20: 'Today\'s Leaderboard TOP 20',
    noRankingData: 'No ranking data',
    interactions: 'interactions',
    fuelPoolRules: 'Fuel Pool Rules',
    rule1: 'Each valid interaction records 0.5-0.6 virtual Gas consumption',
    rule2: 'Daily Points = Interactions + Referral Bonus (20%)',
    rule3: '5 lucky explorers randomly selected daily at UTC 0 from Top 100',
    rule4: 'Winners receive 100 USDT reward',
    rule5: 'Higher points = higher winning probability',
  },
  teamDashboard: {
    loadingTeamData: 'Loading team data...',
    myFleet: 'My Fleet',
    fleetMembers: 'Fleet Members',
    fleetName: 'Fleet Name',
    inviteCode: 'Invite Code',
    inviteFriends: 'Invite Friends to Join',
    copy: 'Copy',
    shareInviteCode: 'Share this invite code with friends to join your fleet!',
    joinFleet: 'Join Fleet',
    enterInviteCode: 'Enter invite code',
    inviteCodePlaceholder: 'Enter fleet invite code (e.g., STORM1234)',
    joining: 'Joining...',
    joinFleetBtn: 'Join Fleet',
    joinFleetDesc: 'Join friends\' fleet via invite code, boost contribution together!',
    thisWeekRankings: 'This Week\'s Rankings',
    thisWeekRankingsTop20: 'This Week\'s Rankings TOP 20',
    noRankingData: 'No ranking data',
    members: 'members',
    contributionRule1: 'Contribution = Captain interactions + (Team member interactions × 10%)',
    contributionRule2: 'Rankings updated every Monday, Top 20 fleets listed',
    contributionExplanation: 'Contribution Rules',
    captainContribution: '👑 Captain Contribution',
    captainContributionFormula: '= Personal interactions + (All member interactions × 10%)',
    memberContribution: '👥 Member Contribution',
    memberContributionFormula: '= Personal interactions (directly counted in team total)',
    teamTotalContribution: '📊 Team Total Contribution',
    teamTotalContributionFormula: '= Sum of all member contributions (for weekly ranking)',
    tip: '💡 Tip: Invite more friends to join your fleet to significantly boost team contribution!',
    createFleet: 'Create Fleet',
    noFleetYet: 'No fleet yet? Create your own!',
    createMyFleet: 'Create My Fleet',
    pleaseConnectWallet: 'Please connect wallet',
    joinSuccess: 'Successfully joined fleet!',
    joinFailed: 'Failed to join fleet',
    createSuccess: 'Fleet created successfully!',
    createFailed: 'Failed to create fleet',
    pleaseRetry: 'Please retry',
  },
  assetDashboard: {
    loadingAssetData: 'Loading asset data...',
    myAssets: 'My Assets',
    usdtBalance: 'USDT Balance',
    canWithdraw: '✓ Can Withdraw',
    charging: '⏳ Charging',
    thresholdReached: 'Threshold reached',
    stillNeed: 'Need {amount} USDT more',
    withdrawalThreshold: 'Withdrawal Threshold: {amount} USDT',
    usdtWithdrawal: 'USDT Withdrawal',
    withdrawalAddress: 'Withdrawal Address',
    withdrawalAddressPlaceholder: 'Enter USDT recipient address (0x...)',
    withdrawalAmount: 'Withdrawal Amount (USDT)',
    withdrawalAmountPlaceholder: '{min} - {max}',
    all: 'All',
    needThreshold: 'Need {amount} USDT to withdraw',
    invalidAddress: 'Please enter a valid withdrawal address',
    invalidAmount: 'Please enter a valid withdrawal amount',
    amountExceeds: 'Withdrawal amount exceeds available balance',
    minWithdrawal: 'Minimum withdrawal amount is {amount} USDT',
    submitting: 'Submitting...',
    submitWithdrawal: 'Submit Withdrawal',
    withdrawalTip1: '💡 Withdrawal requests require admin review',
    withdrawalTip2: '⏰ Will be processed within 1-3 business days after approval',
    transactionHistory: 'Transaction History',
    noTransactions: 'No transaction records',
    rewardIncome: 'Reward Income',
    withdrawalRequest: 'Withdrawal Request',
    completed: 'Completed',
    pending: 'Pending',
    rejected: 'Rejected',
    showRecent: 'Showing recent {count} transactions',
    rewardSources: 'Reward Sources',
    dailyLottery: 'Daily Lottery',
    dailyLotteryDesc: '5 lucky winners daily from Top 100, 100 USDT reward',
    weeklyAirdrop: 'Weekly Airdrop',
    weeklyAirdropDesc: 'Top 20 fleet members receive USDT airdrop weekly',
    interstellarExploration: 'Interstellar Exploration',
    interstellarExplorationDesc: 'Participate in dual-time mining, accumulate energy and potential rewards',
    teamBonus: 'Team Bonus',
    teamBonusDesc: 'Fleet captains get 10% bonus from team member interactions',
    connectWalletToView: 'Connect Wallet to View Assets',
    connectWalletDesc: 'Please connect your wallet to view USDT balance and transaction history',
    pleaseConnectWallet: 'Please connect wallet',
    withdrawalSuccess: 'Withdrawal request submitted! Please wait for admin review.',
    withdrawalFailed: 'Withdrawal request failed',
  },
}
